export default {"src":"/_next/static/media/YJ.290bd14c.svg","height":100,"width":250,"blurWidth":0,"blurHeight":0};